import { createSelector } from 'reselect';

export const getAllStreams = createSelector([convData => convData], convData => {
  if (convData && convData.length > 0) {
    return convData.reduce((prev, now) => {
      const { streams } = now;
      return [...prev, ...streams];
    }, []);
  }
  return [];
});
